module.exports = __webpack_public_path__ + "static/media/favicon.4859e39a.ico";


//////////////////
// WEBPACK FOOTER
// ./public/favicon.ico
// module id = 1526
// module chunks = 1